import { render, staticRenderFns } from "./AvisoLite.vue?vue&type=template&id=1f9824f8&"
import script from "./AvisoLite.vue?vue&type=script&lang=js&"
export * from "./AvisoLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports